// LEGACY: This file is kept for backward compatibility
// The new shadcn-based sidebar is in MainSidebar.jsx

import MainSidebar from "./MainSidebar";

// Re-export the new component to maintain compatibility
const Sidebar = (props) => {
  return <MainSidebar {...props} />;
};

export default Sidebar;